export default {
  token: state => state.token,
  loading: state => state.loading
}
